import React from "react";
/** Competitive intelligence analytics filter bar (Race Tracker). */
import { Label } from "@/race-tracker/components/ui/label";
import { Input } from "@/race-tracker/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/race-tracker/components/ui/select";

const ALL_STATUSES = ["Active", "Inactive", "Done"];
const ALL_AGENCIES = ["SMG", "DCM", "DRM", "SMG/DCM", "No Client"];
const ANALYSTS = ["Dan", "Evan", "Ian", "James"];

export default function AnalyticsFilters({ filters, onChange }) {
  const toggleStatus = (val) => {
    const next = filters.status.includes(val)
      ? filters.status.filter((s) => s !== val)
      : [...filters.status, val];
    onChange({ ...filters, status: next });
  };

  const toggleAgency = (val) => {
    const next = filters.agency.includes(val)
      ? filters.agency.filter((a) => a !== val)
      : [...filters.agency, val];
    onChange({ ...filters, agency: next });
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 space-y-4">
      <p className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">Filters</p>
      <div className="flex flex-wrap items-start gap-6">
        {/* Status */}
        <div className="space-y-1.5">
          <Label className="text-xs">Status</Label>
          <div className="flex flex-wrap gap-1.5">
            {ALL_STATUSES.map((s) => {
              const active = filters.status.includes(s);
              return (
                <button
                  key={s}
                  onClick={() => toggleStatus(s)}
                  className={`text-xs px-2.5 py-1 rounded-md border font-medium transition-all ${
                    active
                      ? "bg-primary text-primary-foreground border-primary"
                      : "bg-background text-muted-foreground border-border hover:border-primary/50"
                  }`}
                >
                  {s}
                </button>
              );
            })}
          </div>
        </div>

        {/* Agency */}
        <div className="space-y-1.5">
          <Label className="text-xs">Agency</Label>
          <div className="flex flex-wrap gap-1.5">
            {ALL_AGENCIES.map((a) => {
              const active = filters.agency.includes(a);
              return (
                <button
                  key={a}
                  onClick={() => toggleAgency(a)}
                  className={`text-xs px-2.5 py-1 rounded-md border font-medium transition-all ${
                    active
                      ? "bg-primary text-primary-foreground border-primary"
                      : "bg-background text-muted-foreground border-border hover:border-primary/50"
                  }`}
                >
                  {a}
                </button>
              );
            })}
          </div>
        </div>

        {/* Data Analyst */}
        <div className="space-y-1.5">
          <Label className="text-xs">Data Analyst</Label>
          <Select value={filters.da} onValueChange={(v) => onChange({ ...filters, da: v })}>
            <SelectTrigger className="h-8 text-xs w-32">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">All</SelectItem>
              {ANALYSTS.map((a) => <SelectItem key={a} value={a}>{a}</SelectItem>)}
            </SelectContent>
          </Select>
        </div>

        {/* Staleness Threshold */}
        <div className="space-y-1.5">
          <Label className="text-xs">Flag sweeps older than</Label>
          <div className="flex items-center gap-2">
            <Input
              type="number"
              min={1}
              className="h-8 text-xs w-20"
              value={filters.staleness_days}
              onChange={(e) => onChange({ ...filters, staleness_days: Math.max(1, Number(e.target.value) || 1) })}
            />
            <span className="text-xs text-muted-foreground">days</span>
          </div>
        </div>
      </div>
    </div>
  );
}